import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  loadScheduledReports,
  saveScheduledReport,
  toggleScheduledReport,
  deleteScheduledReport,
} from "../../Redux/Actions/ActionStatistics";
import "./ScheduledReports.css";

/**
 * BE-7 + FE-12 — Scheduled Reports Manager
 * Create / toggle / delete scheduled report notifications.
 *
 * Props:
 *   translate — i18n function
 */

const REPORT_OPTIONS = [
  { key: "marketing_tools_report", labelKey: "marketing_tools_report" },
  { key: "free_samples_summarized_report", labelKey: "free_samples_summarized_report" },
  { key: "hospital", labelKey: "hospital" },
  { key: "get_products_stock_report", labelKey: "get_products_stock_report" },
  { key: "get_markitings_stock_report", labelKey: "get_markitings_stock_report" },
  { key: "objection_rebort", labelKey: "objection_rebort" },
  { key: "monthly_orders_report", labelKey: "monthly_orders_report" },
  { key: "products_monthly_salesReport", labelKey: "products_monthly_salesReport" },
];

const FREQUENCIES = [
  { value: "daily", labelKey: "schedule_daily" },
  { value: "weekly", labelKey: "schedule_weekly" },
  { value: "monthly", labelKey: "schedule_monthly" },
];

function ScheduledReports({ translate }) {
  const dispatch = useDispatch();
  const reports = useSelector((s) => s.statisticss.scheduledReports) || [];

  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    name: "",
    report_key: REPORT_OPTIONS[0].key,
    frequency: "daily",
    send_at: "08:00",
  });

  useEffect(() => {
    dispatch(loadScheduledReports());
  }, [dispatch]);

  const handleSubmit = () => {
    if (!form.name.trim()) return;
    dispatch(saveScheduledReport(form, () => {
      setForm({ name: "", report_key: REPORT_OPTIONS[0].key, frequency: "daily", send_at: "08:00" });
      setShowForm(false);
    }));
  };

  return (
    <div className="scheduled-reports">
      <div className="sr-header">
        <span className="las la-bell"></span>
        <span>{translate("scheduled_reports_title")}</span>
        <button className="sr-add-btn" onClick={() => setShowForm((p) => !p)}>
          <span className={showForm ? "las la-minus" : "las la-plus"}></span>
        </button>
      </div>

      {/* Create form */}
      {showForm && (
        <div className="sr-form">
          <input
            className="sr-input"
            type="text"
            placeholder={translate("schedule_name_placeholder")}
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
          <select
            className="sr-select"
            value={form.report_key}
            onChange={(e) => setForm({ ...form, report_key: e.target.value })}
          >
            {REPORT_OPTIONS.map((r) => (
              <option key={r.key} value={r.key}>
                {translate(r.labelKey)}
              </option>
            ))}
          </select>
          <select
            className="sr-select"
            value={form.frequency}
            onChange={(e) => setForm({ ...form, frequency: e.target.value })}
          >
            {FREQUENCIES.map((f) => (
              <option key={f.value} value={f.value}>
                {translate(f.labelKey)}
              </option>
            ))}
          </select>
          <input
            className="sr-input sr-time"
            type="time"
            value={form.send_at}
            onChange={(e) => setForm({ ...form, send_at: e.target.value })}
          />
          <button className="sr-btn sr-btn-save" onClick={handleSubmit}>
            {translate("templates_save")}
          </button>
        </div>
      )}

      {/* List */}
      <div className="sr-list">
        {reports.length === 0 && (
          <div className="sr-empty">{translate("schedule_empty")}</div>
        )}
        {reports.map((r) => (
          <div key={r.id} className={`sr-item${r.is_active ? "" : " inactive"}`}>
            <div className="sr-item-info">
              <span className="sr-item-name">{r.name}</span>
              <span className="sr-item-meta">
                {translate(r.report_key)} · {translate(`schedule_${r.frequency}`)} · {r.send_at}
              </span>
            </div>
            <div className="sr-item-actions">
              <button
                className={`sr-toggle ${r.is_active ? "active" : ""}`}
                onClick={() => dispatch(toggleScheduledReport(r.id))}
                title={r.is_active ? translate("schedule_deactivate") : translate("schedule_activate")}
              >
                <span className={`las ${r.is_active ? "la-toggle-on" : "la-toggle-off"}`}></span>
              </button>
              <button
                className="sr-btn sr-btn-delete"
                onClick={() => dispatch(deleteScheduledReport(r.id))}
              >
                <span className="las la-trash"></span>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ScheduledReports;
